import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { Avatar, StickyHeaderNavigation } from '@/components'
import { AmountDisplay } from '@/components/AmountDisplay'
import {
  TransferOutSettingsAndFees,
  CreateTransferOutButton,
} from '@/features/savings'
import { useSavingsStore } from '@/store/useSavingsStore'
import { currencyUtils } from '@/utils'
import useOffsets from '@/hooks/useOffsets'

const { formatFiatCurrency } = currencyUtils

export default function ConfirmTransferOutScreen() {
  const { t } = useTranslation()
  const offsets = useOffsets()

  const goalTransferOut = useSavingsStore((s) => s.goalTransferOut)

  const formattedFiatAmount = formatFiatCurrency({
    value: Number(goalTransferOut.fiatAmount.amount),
    fiatCode: goalTransferOut.fiatAmount.code as any,
    showDecimals: true,
  })

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        minHeight: '100vh',
        backgroundColor: 'var(--color-background-screen)',
      }}
    >
      <StickyHeaderNavigation title={t('form:actions.transferOut')} />

      <BaseView
        style={{
          paddingTop: offsets.top + 70,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
        pt={24}
        px={13}
      >
        <BaseView gap={40}>
          {/* Avatar - right arrow as in React Native */}
          <Avatar
            iconName="arrowRightCircle"
            iconSize={68}
            size={127}
            containerStyle={{ alignSelf: 'center' }}
          />

          {/* Amount Display - use new component */}
          <AmountDisplay
            amount={goalTransferOut.cryptoAmount.amount}
            currencyCode={goalTransferOut.cryptoAmount.code}
            sign="-"
            shouldRemoveTrailingZeros
            equivalentAmountFormatted={formattedFiatAmount}
            containerProps={{ gap: 18 }}
          />
        </BaseView>

        {/* Settings and Fees */}
        <TransferOutSettingsAndFees />

        {/* Fixed Button at Bottom */}
        <BaseView mt="auto" style={{ paddingBottom: offsets.bottom }}>
          <CreateTransferOutButton />
        </BaseView>
      </BaseView>
    </div>
  )
}
